<template>
  <div class="rvr-radiobutton">
    <div
        v-for="(option, index) in options"
        :key="index"
        class="rvr-radiobutton-option"
    >
      <input
          type="radio"
          :id="`${option.value}-${name}`"
          :name="name"
          :value="option.value"
          v-model="internalValue"
      />
      <label :class="`rvr-radiobutton-${option.value}`" :for="`${option.value}-${name}`">{{ option.label }}</label>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  name: "RadioButton",
  props: {
    modelValue: {
      type: [String, null],
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const internalValue = ref(props.modelValue);

    watch(internalValue, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      internalValue.value = newValue;
    });

    return { internalValue };
  },
};
</script>

<style scoped>
.rvr-radiobutton {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e9e9e9;
  background-color: #f8f9fa;
  border-radius: 10px;
  width: fit-content;
  font-size: 1em;
}

.rvr-radiobutton-option {
  border-radius: 7px;
  padding: 5px 0 5px;
}
.rvr-radiobutton input[type="radio"] {
  display: none;
}
.rvr-radiobutton .rvr-radiobutton-option:first-child label {
  border-radius: 7px 0 0 7px;
}
.rvr-radiobutton .rvr-radiobutton-option:last-child label {
  border-radius: 0 7px 7px 0;
}
.rvr-radiobutton label {
  padding: 10px;
  cursor: pointer;
  color: #bbb;
}

.rvr-radiobutton input[type="radio"]:checked + label {
  background-color: #2e8e83;
  color: #fff;
}

.rvr-radiobutton:focus-within {
  outline: auto 2px Highlight;
  outline: 5px auto -webkit-focus-ring-color;
}
</style>
